/* ============================================================================
   KARMA-MERES: mérés-védett fájl, módosítás csak jóváhagyással.
   dataLayer-alapreteg (wrapper + user-data + item-mapper) es esemeny-motor:
   - auto-scan: script[data-karma-dl] adatbeagyazasok feldolgozasa
     (view_item, view_item_list, form_success) + select_item klikk-figyeles
   - kosar-motor: fetch-elfogas a /cart/add|change|update|clear utakon,
     /cart.js diff -> add_to_cart / remove_from_cart; view_cart (oldal + drawer)
   - meretkalkulator: add_size + click_sizecalculator_cta
   Kontextus es szabalyok: docs/MERES.md
   ============================================================================ */
(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  var ctx = window.karmaDLContext || {};

  var HU_PREFIXES = ['20', '30', '31', '50', '70', '1', '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '32', '33', '34', '35', '36', '37', '42', '44', '45', '46', '47', '48', '49', '52', '53', '54', '56', '57', '59',
    '62', '63', '66', '69', '72', '73', '74', '75', '76', '77', '78', '79', '82', '83', '84', '85', '87', '88', '89',
    '92', '93', '94', '95', '96', '99'];

  function phoneDigits(raw, dc) {
    if (raw == null) return null;
    var s = String(raw).trim();
    if (!s) return null;
    var hadPlus = s.charAt(0) === '+';
    var digits = s.replace(/\D/g, '');
    if (!digits) return null;
    if (hadPlus) return digits;
    if (digits.indexOf('00') === 0) return digits.slice(2) || null;
    if (digits.indexOf('06') === 0) return dc + digits.slice(2);
    if (digits.indexOf(dc) === 0) {
      var rest = digits.slice(dc.length);
      if (rest.length >= 8 && rest.length <= 9) return digits;
    }
    for (var i = 0; i < HU_PREFIXES.length; i++) {
      var p = HU_PREFIXES[i];
      if (digits.indexOf(p) === 0 && (digits.length === 8 || digits.length === 9)) {
        return dc + digits;
      }
    }
    if (digits.length === 8 || digits.length === 9) return dc + digits;
    return digits;
  }

  function lower(s) { return s ? String(s).trim().toLowerCase() : null; }

  function metaClean(s) {
    return s ? String(s).trim().toLowerCase().replace(/[^0-9a-zÀ-ɏ]/gi, '') : null;
  }

  function googleEmail(e) {
    if (!e) return null;
    var b = String(e).trim().toLowerCase();
    var at = b.indexOf('@');
    if (at < 0) return b;
    var u = b.slice(0, at);
    var d = b.slice(at + 1);
    if (d === 'gmail.com' || d === 'googlemail.com') return u.replace(/\./g, '') + '@' + d;
    return b;
  }

  function setKey(key, val) {
    try {
      if (val) sessionStorage.setItem(key, val);
      else sessionStorage.removeItem(key);
    } catch (e) { /* storage tiltva: mereskiesest nem okozhat */ }
  }

  function getKey(key) {
    try { return sessionStorage.getItem(key) || undefined; } catch (e) { return undefined; }
  }

  /* fields: {email, phone, first_name, last_name, city, zip, country} - nyers ertekek */
  function saveUserData(fields) {
    if (!fields) return;
    if ('email' in fields) {
      setKey('ud_em', lower(fields.email));
      setKey('ud_em_gads', googleEmail(fields.email));
    }
    if ('phone' in fields) {
      var pd = phoneDigits(fields.phone, '36');
      setKey('ud_ph', pd);
      setKey('ud_ph_plus', pd ? '+' + pd : null);
    }
    if ('first_name' in fields) setKey('ud_fn', lower(fields.first_name));
    if ('last_name' in fields) setKey('ud_ln', lower(fields.last_name));
    if ('city' in fields) setKey('ud_ct', metaClean(fields.city));
    if ('zip' in fields) setKey('ud_zp', fields.zip ? String(fields.zip).trim().toLowerCase().replace(/[\s-]/g, '') : null);
    if ('country' in fields) setKey('ud_country', lower(fields.country));
  }

  function readUserData() {
    var out = {};
    var map = {
      email: 'ud_em', email_gads: 'ud_em_gads', phone: 'ud_ph', phone_plus: 'ud_ph_plus',
      first_name: 'ud_fn', last_name: 'ud_ln', city: 'ud_ct', postal_code: 'ud_zp', country: 'ud_country'
    };
    var has = false;
    for (var k in map) {
      var v = getKey(map[k]);
      if (v) { out[k] = v; has = true; }
    }
    return has ? out : null;
  }

  /* item_id = modell+szin szint: teljes SKU minusz az utolso (meret-)szegmens */
  function itemIdFromSku(sku, fallback) {
    if (!sku) return fallback != null ? String(fallback) : null;
    var i = String(sku).lastIndexOf('-');
    return i > 0 ? String(sku).slice(0, i) : String(sku);
  }

  /* a /cart.js valasz egy line-jabol GA4 item (kosar-esemenyekhez) */
  function itemFromCartLine(line, extra) {
    var item = {
      item_id: itemIdFromSku(line.sku, line.product_id),
      item_sku: line.sku || undefined,
      item_product_id: String(line.product_id),
      item_variant_id: String(line.id),
      item_name: line.product_title,
      item_brand: 'KARMA',
      item_variant: line.variant_title || undefined,
      price: Math.round(line.final_price) / 100,
      quantity: line.quantity
    };
    if (line.original_price > line.final_price) {
      item.discount = Math.round(line.original_price - line.final_price) / 100;
    }
    if (line.product_type) item.item_category = line.product_type;
    if (extra) for (var k in extra) item[k] = extra[k];
    return item;
  }

  function listValue(items) {
    var v = 0;
    for (var i = 0; i < items.length; i++) v += (items[i].price || 0) * (items[i].quantity || 1);
    return Math.round(v * 100) / 100;
  }

  window.karmaDL = {
    currency: ctx.currency || 'HUF',
    /* ecommerce-event: karmaDL.push('add_to_cart', {currency:..., value:..., items:[...]})
       sima event:      karmaDL.push('newsletter_subscription', null, {form_location:'footer'}) */
    push: function (eventName, ecommerce, extra) {
      var payload = { event: eventName };
      if (ecommerce) {
        window.dataLayer.push({ ecommerce: null });
        payload.ecommerce = ecommerce;
      }
      var ud = readUserData();
      if (ud) payload.user_data = ud;
      if (extra) for (var k in extra) payload[k] = extra[k];
      window.dataLayer.push(payload);
    },
    saveUserData: saveUserData,
    readUserData: readUserData,
    itemIdFromSku: itemIdFromSku,
    itemFromCartLine: itemFromCartLine
  };

  function pushOnce(key, eventName, ecommerce, extra) {
    if (getKey(key)) return;
    setKey(key, '1');
    window.karmaDL.push(eventName, ecommerce, extra);
  }

  /* bejelentkezett vevo: seed csak ures kulcsokra (a form-adat frissebb, ne irjuk felul) */
  if (ctx.customer) {
    var c = ctx.customer;
    var seed = {};
    if (c.email && !getKey('ud_em')) seed.email = c.email;
    if (c.phone && !getKey('ud_ph')) seed.phone = c.phone;
    if (c.first_name && !getKey('ud_fn')) seed.first_name = c.first_name;
    if (c.last_name && !getKey('ud_ln')) seed.last_name = c.last_name;
    saveUserData(seed);
  }

  /* ===== form-figyeles: user_data gyujtese a hirlevel/kapcsolat urlapokrol =====
     A beirt email/nev/telefon MENTESE mar gepeles kozben (blur), hogy a sikeres
     bekuldes utani oldalbetolteskor a form-event mar user_data-val menjen ki
     (Enhanced Conversions + Meta advanced matching). */

  function formFigyelo() {
    var mezok = [
      { sel: 'input[type="email"], input[name="contact[email]"], input[name="email"]', kulcs: 'email' },
      { sel: 'input[type="tel"], input[name="contact[phone]"], input[name="phone"]', kulcs: 'phone' },
      { sel: 'input[name="contact[first_name]"], input[name="first_name"]', kulcs: 'first_name' },
      { sel: 'input[name="contact[last_name]"], input[name="last_name"]', kulcs: 'last_name' }
    ];
    function ment(el, kulcs) {
      var v = (el.value || '').trim();
      if (!v) return;
      var o = {};
      o[kulcs] = v;
      saveUserData(o);
    }
    /* delegalt figyeles: a kesobb betoltodo (drawer, popup) urlapokra is */
    document.addEventListener('blur', function (ev) {
      var t = ev.target;
      if (!t || !t.matches) return;
      for (var i = 0; i < mezok.length; i++) {
        if (t.matches(mezok[i].sel)) { ment(t, mezok[i].kulcs); return; }
      }
    }, true);
    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (!f || !f.querySelectorAll) return;
      for (var i = 0; i < mezok.length; i++) {
        var el = f.querySelector(mezok[i].sel);
        if (el) ment(el, mezok[i].kulcs);
      }
      /* a "contact[Név]" jellegu, egy mezos nevet is elmentjuk keresztnevkent */
      var nev = f.querySelector('input[name="contact[Név]"], input[name="contact[name]"]');
      if (nev && (nev.value || '').trim()) {
        var reszek = nev.value.trim().split(/\s+/);
        /* magyar sorrend: vezeteknev elol */
        saveUserData({ last_name: reszek[0], first_name: reszek.slice(1).join(' ') || reszek[0] });
      }
    }, true);
  }

  /* ===== esemeny-motor: adatbeagyazasok (script[data-karma-dl]) ===== */

  var lists = [];

  function stripUrl(item) {
    var out = {};
    for (var k in item) if (k !== 'url') out[k] = item[k];
    return out;
  }

  function processNode(node) {
    if (node.dataset.karmaDlDone) return;
    node.dataset.karmaDlDone = '1';
    var kind = node.dataset.karmaDl;
    var payload;
    try { payload = JSON.parse(node.textContent || '{}'); } catch (e) { return; }
    if (kind === 'view_item' && payload.items && payload.items.length) {
      window.karmaDL.push('view_item', {
        currency: window.karmaDL.currency,
        value: listValue(payload.items),
        items: payload.items.map(stripUrl)
      });
    } else if (kind === 'view_item_list' && payload.items && payload.items.length) {
      var listId = node.dataset.listId || undefined;
      var listName = node.dataset.listName || undefined;
      lists.push({ id: listId, name: listName, items: payload.items });
      window.karmaDL.push('view_item_list', {
        currency: window.karmaDL.currency,
        item_list_id: listId,
        item_list_name: listName,
        items: payload.items.map(stripUrl)
      });
    } else if (kind === 'form_success' && node.dataset.event) {
      pushOnce('karma_once_' + node.dataset.event + '_' + (node.dataset.formLocation || ''),
        node.dataset.event, null, { form_location: node.dataset.formLocation || undefined });
    }
  }

  function scan() {
    var nodes = document.querySelectorAll('script[type="application/json"][data-karma-dl]');
    for (var i = 0; i < nodes.length; i++) processNode(nodes[i]);
  }

  /* select_item: kartya-kattintas illesztese a regisztralt listak item-url-jeire */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a || !lists.length) return;
    var path;
    try { path = new URL(a.getAttribute('href'), location.origin).pathname; } catch (e) { return; }
    for (var i = lists.length - 1; i >= 0; i--) {
      var L = lists[i];
      for (var j = 0; j < L.items.length; j++) {
        var u = L.items[j].url;
        if (u && u.split('?')[0] === path) {
          window.karmaDL.push('select_item', {
            item_list_id: L.id,
            item_list_name: L.name,
            items: [stripUrl(L.items[j])]
          });
          return;
        }
      }
    }
  }, true);

  /* ===== kosar-motor =====
     Onjavito diff: a mindenkori allapot sessionStorage-snapshotban is el, es
     oldalbetolteskor a szerver-renderelt friss kosarat osszevetjuk vele - igy a
     reload/redirect kozben elveszett add/remove esemenyek POTLODNAK (pl. a
     zsak-upsell location.reload()-ja az eloszobaban). */

  var IS_ELOSZOBA = location.pathname.indexOf('/apps/checkout') !== -1;
  var SNAP_KEY = 'karma_cart_snap';
  var cartState = {};

  function locName() {
    if (ctx.page_type === 'cart') return 'cart_page';
    if (IS_ELOSZOBA) return 'checkout_page';
    return 'mini_cart';
  }

  function snapshotFrom(items) {
    var m = {};
    for (var i = 0; i < (items || []).length; i++) m[items[i].id] = items[i];
    return m;
  }

  function cartItems() {
    var out = [];
    for (var id in cartState) out.push(itemFromCartLine(cartState[id]));
    return out;
  }

  function writeSnap() {
    try {
      var arr = [];
      for (var id in cartState) arr.push(cartState[id]);
      sessionStorage.setItem(SNAP_KEY, JSON.stringify({ currency: window.karmaDL.currency, items: arr }));
    } catch (e) {}
  }

  function readSnap() {
    try { return JSON.parse(sessionStorage.getItem(SNAP_KEY) || 'null'); } catch (e) { return null; }
  }

  /* delta-esemenyek ket allapot kozott; a snapshot-irast a hivo vegzi */
  function emitDiff(prev, next, currency) {
    var added = [], removed = [], id, d;
    for (id in next) {
      d = next[id].quantity - (prev[id] ? prev[id].quantity : 0);
      if (d > 0) added.push(itemFromCartLine(next[id], { quantity: d }));
    }
    for (id in prev) {
      d = prev[id].quantity - (next[id] ? next[id].quantity : 0);
      if (d > 0) removed.push(itemFromCartLine(prev[id], { quantity: d }));
    }
    if (added.length) {
      window.karmaDL.push('add_to_cart', { currency: currency, value: listValue(added), items: added });
    }
    if (removed.length) {
      window.karmaDL.push('remove_from_cart', { currency: currency, value: listValue(removed), items: removed },
        { event_location: locName() });
    }
  }

  /* betolteskori kiegyenlites: kimaradt esemenyek potlasa a friss szerver-allapotbol */
  (function reconcile() {
    var fresh = snapshotFrom((ctx.cart && ctx.cart.items) || []);
    var stored = readSnap();
    if (stored && stored.currency === window.karmaDL.currency) {
      var prev = snapshotFrom(stored.items);
      var freshEmpty = true, prevAny = false, k;
      for (k in fresh) { freshEmpty = false; break; }
      for (k in prev) { prevAny = true; break; }
      /* ures friss kosar + korabbi tetelek = valoszinuleg purchase/lejarat ->
         NEM remove_from_cart, csak csendes reset */
      if (!(freshEmpty && prevAny)) emitDiff(prev, fresh, window.karmaDL.currency);
    }
    cartState = fresh;
    writeSnap();
  })();

  var diffBusy = false, diffAgain = false, diffCbs = [];
  var mutCount = 0, pendingViewCart = null;

  function pushViewCart(loc) {
    var items = cartItems();
    window.karmaDL.push('view_cart', {
      currency: window.karmaDL.currency,
      value: listValue(items),
      items: items
    }, { event_location: loc });
  }

  function flushViewCart() {
    if (pendingViewCart && !diffBusy && mutCount === 0) {
      var loc = pendingViewCart;
      pendingViewCart = null;
      pushViewCart(loc);
    }
  }

  function requestViewCart(loc) {
    if (diffBusy || mutCount > 0) pendingViewCart = loc;
    else pushViewCart(loc);
  }

  function cartDiff(cb) {
    if (cb) diffCbs.push(cb);
    if (diffBusy) { diffAgain = true; return; }
    diffBusy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    origFetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var next = snapshotFrom(cart.items);
        emitDiff(cartState, next, cart.currency || window.karmaDL.currency);
        cartState = next;
        writeSnap();
      })
      .catch(function () {})
      .then(function () {
        diffBusy = false;
        if (diffAgain) { diffAgain = false; cartDiff(); return; }
        var cbs = diffCbs;
        diffCbs = [];
        for (var i = 0; i < cbs.length; i++) { try { cbs[i](); } catch (e) {} }
        flushViewCart();
      });
  }

  function mutDone() { mutCount = Math.max(0, mutCount - 1); flushViewCart(); }

  var origFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var url = typeof arg === 'string' ? arg : ((arg && arg.url) || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      mutCount++;
      p.then(function (res) {
        if (res && res.ok) setTimeout(function () { cartDiff(mutDone); }, 10);
        else mutDone();
      }, function () { mutDone(); });
    }
    return p;
  };

  function bindDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.dataset.karmaDlDrawer) return;
    d.dataset.karmaDlDrawer = '1';
    new MutationObserver(function () {
      var open = d.classList.contains('active');
      if (open && !d.dataset.karmaDlOpen) {
        d.dataset.karmaDlOpen = '1';
        requestViewCart('mini_cart');
      } else if (!open && d.dataset.karmaDlOpen) {
        delete d.dataset.karmaDlOpen;
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  /* ===== eloszoba (/apps/checkout): begin_checkout + submit-esemenyek =====
     A proxy.js-hez NEM nyulunk: az azonositok (#kGo, input[name=m], input[name=p])
     az eloszoba stabil DOM-kontraktusa - valtozas eseten itt kell kovetni. */

  function pushBeginCheckout() {
    /* zsak-upsell reload / vissza-navigalas ne duplazza a tolcser-belepest */
    var last = parseInt(getKey('karma_bc_ts') || '0', 10);
    if (Date.now() - last < 30 * 60 * 1000) return;
    setKey('karma_bc_ts', String(Date.now()));
    var items = cartItems();
    window.karmaDL.push('begin_checkout', {
      currency: window.karmaDL.currency,
      value: listValue(items),
      items: items
    });
  }

  var lastSubmitKey = '', lastSubmitTs = 0;

  function bindEloszoba() {
    if (!IS_ELOSZOBA) return;
    document.addEventListener('click', function (ev) {
      var go = ev.target && ev.target.closest ? ev.target.closest('#kGo') : null;
      if (!go) return;
      var m = document.querySelector('input[name=m]:checked');
      var p = document.querySelector('input[name=p]:checked');
      var key = (m ? m.value : '') + '|' + (p ? p.value : '');
      if (key === lastSubmitKey && Date.now() - lastSubmitTs < 15000) return;
      lastSubmitKey = key;
      lastSubmitTs = Date.now();
      var items = cartItems();
      window.karmaDL.push('add_shipping_info', {
        currency: window.karmaDL.currency,
        value: listValue(items),
        shipping_tier: m ? m.value : undefined,
        items: items
      });
      window.karmaDL.push('add_payment_info', {
        currency: window.karmaDL.currency,
        value: listValue(items),
        payment_type: p ? p.value : undefined,
        items: items
      });
    }, true);
  }

  /* ===== meretkalkulator: add_size + click_sizecalculator_cta ===== */

  function bindKalk() {
    var root = document.getElementById('kalkulator');
    if (!root || root.dataset.karmaDlKalk) return;
    root.dataset.karmaDlKalk = '1';
    var out = root.querySelector('[data-kalk-eredmeny]');
    var lastPushed = '', timer = null;

    function currentGender() {
      var g = root.querySelector('[data-kalk-nem][aria-pressed="true"]');
      return g ? g.dataset.kalkNem : undefined;
    }

    function currentSize() {
      var el = out && out.querySelector('.karma-kalk__eszam');
      return el ? (el.textContent || '').trim().replace(',', '.') : '';
    }

    if (out) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var size = currentSize();
          if (!size) return;
          var key = size + '|' + currentGender();
          if (key === lastPushed) return;
          lastPushed = key;
          window.karmaDL.push('add_size', null, { size_value: size, gender: currentGender() });
        }, 800);
      }).observe(out, { childList: true, subtree: true });
    }

    root.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('.karma-kalk__ecta a') : null;
      if (!a) return;
      window.karmaDL.push('click_sizecalculator_cta', null, { size_value: currentSize() || undefined });
    }, true);
  }

  /* ===== inditas + ujra-scan DOM-valtozaskor (facet-szures, drawer-csere) ===== */

  function boot() {
    scan();
    bindDrawer();
    bindKalk();
    bindEloszoba();
    formFigyelo();
    if (ctx.page_type === 'cart') pushViewCart('cart_page');
    if (IS_ELOSZOBA) pushBeginCheckout();
  }

  var scanTimer = null;
  new MutationObserver(function () {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () { scan(); bindDrawer(); bindKalk(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
